import React from 'react';

var _path;

var SvgSelectMinor = function SvgSelectMinor(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", Object.assign({
      viewBox: "0 0 20 20"
    }, props), _path || (_path =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M7.676 9h4.648c.563 0 .879-.603.53-1.014L10.531 5.24a.708.708 0 0 0-1.062 0L7.145 7.986C6.798 8.397 7.113 9 7.676 9zm4.648 2H7.676c-.563 0-.878.603-.53 1.014l2.323 2.746c.27.32.792.32 1.062 0l2.323-2.746c.349-.411.033-1.014-.53-1.014z"
    })))
  );
};

export { SvgSelectMinor as S };